"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

import {
  captureAnalyticsEvent,
  useAnalyticsConsent,
} from "@/components/analytics/analytics-provider";
import { type AnalyticsPageScope, getPageViewEventName } from "@/lib/analytics/events";

export function RouteAnalytics({ scope }: { scope: AnalyticsPageScope }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { canTrackPostHogEvents } = useAnalyticsConsent();
  const search = searchParams.toString();

  useEffect(() => {
    if (!canTrackPostHogEvents || !pathname) {
      return;
    }

    const fullPath = search ? `${pathname}?${search}` : pathname;
    captureAnalyticsEvent(getPageViewEventName(scope), {
      full_path: fullPath,
      path: pathname,
      route_scope: scope,
    });
  }, [canTrackPostHogEvents, pathname, scope, search]);

  return null;
}
